// extracted by mini-css-extract-plugin
module.exports = {"priceInput":"order-bump_priceInput__13du2","describeInput":"order-bump_describeInput__1luEj","description":"order-bump_description__1fTSO","length":"order-bump_length__2GxSQ"};